import { useState } from 'react';
import { PageHead } from '../components/ui';
import { Tabs } from './am/amUi';
import { ProjectsAutotaskDashboard } from './ProjectsAutotaskDashboard';
import { ProjectsSchedule } from './ProjectsSchedule';
import { ProjectsTimeByResource } from './ProjectsTimeByResource';

/**
 * Projects — from Autotask: the dashboard of every project, and the time each
 * resource put into project work over the days you choose.
 *
 * The page used to lead with the Professional Services portal moved in from
 * `C:\Development\Project` (its own project list, roll-up and KPI launch).
 * Those tabs are gone from the page; the projects they held are still in the
 * database and the /api/projects routes still answer (migration 043), so
 * nothing was lost — Autotask is simply where projects are run now.
 */
type Tab = 'dashboard' | 'schedule' | 'time';

export function ProjectsPage() {
  const [tab, setTab] = useState<Tab>('dashboard');
  return (
    <>
      <PageHead
        title="Projects"
        lede="Every project in Autotask: what is open, what is late or over its hours, who leads what, what has finished — who worked on what, and who the work still to do falls on."
      />
      <Tabs<Tab>
        tabs={[
          { key: 'dashboard', label: 'Autotask dashboard' },
          { key: 'schedule', label: 'Schedule' },
          { key: 'time', label: 'Time by resource' },
        ]}
        active={tab}
        onChange={setTab}
      />
      {tab === 'dashboard' && <ProjectsAutotaskDashboard />}
      {tab === 'schedule' && <ProjectsSchedule />}
      {tab === 'time' && <ProjectsTimeByResource />}
    </>
  );
}
